<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4" v-if="currentTrail">
          <div class="card-header pt-1 pb-0">
            <div>
              <h3 class="card-title text-primary mb-0">Sendero {{ currentTrail.name }}</h3>
              <div class="sub-line"></div>
              <div class="row col-12 mt-3">
                <router-link :to="{ name: 'Senderos' }"
                             class="col-md-2 col-6 col-md-offset-10 btn btn-primary btn-sm text-white bg-blue-600 rounded-lg hover:bg-blue-900 mb-0  ml-auto">
                  Ir al listado
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="card">
              <div class="card-body">
            <div class="row" v-if="currentTrail">
              <div class="col-md-6">
                <div>
                  <label for="employee_name" class="form-control-label">
                    Nombre
                  </label>
                  <p>{{ currentTrail.name }}</p>
                </div>
                <div>
                  <label class="form-control-label">
                    Dificultad
                  </label>
                 <p> {{ currentTrail.difficulty }}</p>
                </div>
                <div>
                  <label class="form-control-label">
                    Duración
                  </label>
                  <p> {{ currentTrail.duration }}</p>
                </div>
                <div>
                  <label class="form-control-label">
                    Latitud
                  </label>
                  <p> {{ currentTrail.latitude }}</p>
                </div>
                <div>
                  <label class="form-control-label">
                    Longitud
                  </label>
                  <p> {{ currentTrail.longitude }}</p>
                </div>
                <div>
                  <label class="form-control-label">
                    Video
                  </label>
                  <video  width="200" autoplay muted v-if="currentTrail.videoUrl" :src="currentTrail.videoUrl"> </video>
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-control-label">
                  Imágenes
                </label>
                <ul class="row list-unstyled">
                  <li  class="col-6" v-for="item in currentTrail.images" :key="item.id">
                    <img class="img-thumbnail" width="200" :src="item.imageUrl">

                  </li>

                </ul>
                <label class="form-control-label">
                  Imágenes 360
                  </label>
                  <ul class="row list-unstyled">
                    <li  class="col-6" v-for="item in currentTrail.images360" :key="item.id">
                      <img class="img-thumbnail" width="200" :src="item.imageUrl">

                    </li>
                </ul>
                <div>
                <label class="form-control-label">
                  Archivo de ruta:
                  <p>
                    <a target="_blank" :href="currentTrail.gpxUrl">{{currentTrail.filePath}}</a>
                  </p>
                </label>
                </div>
                <div>
                  <label class="form-control-label">
                    Archivo de mapas:
                    <p><a target="_blank" :href="currentTrail.tilesUrl">{{currentTrail.tilesUrl}}</a></p>
                  </label>
                </div>
              </div>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";


     const route = useRoute();
     const store = useStore();

    const getCurrentTrail = async (id) => {
      return await store.dispatch("trail/getTrailById", id);
    };

    const currentTrail = computed(() => store.state.trail.currentTrail);

    onMounted(()=>{
      getCurrentTrail(route.params.id)
    });


</script>
